import { CurrencyDollarIcon } from "@heroicons/react/24/outline"
import { Route, Routes } from "react-router-dom"
import { RouteElement } from "../../../interfaces/_common"
import { SubMenuTabs } from "../common"
import RouteKeys from "constants/route-keys"
import { lazy } from "react"
const PlanListing =  lazy(() => import("../PlanManagement/PlanListing"))
const TableListing = lazy(() => import("../PlanManagement/TableListing"))
const ViewModeIndex = lazy(() => import("../PlanManagement/ViewMode"))

const _routes: RouteElement[] = [
  {
    route: '',
    component: PlanListing,
    title: 'Plans',
    key: RouteKeys.PLAN,
    icon: CurrencyDollarIcon,
    display: true
  },
  {
    route: 'add',
    component: TableListing,
    title: 'Add Plans',
    key:RouteKeys.PLAN,
    icon: CurrencyDollarIcon,
  },
  {
    route: 'view',
    component: ViewModeIndex,
    title: 'View Plans',
    key:RouteKeys.PLAN,
    icon: CurrencyDollarIcon,
    display: false
  },
]

const MonetizationConfiguration = () => {
  return (
         <div>
             <SubMenuTabs _routes={_routes} />
             <div className="p-3">
                 <Routes>
                     {
                         _routes.map((route, index) => (
                             <Route key={index} path={`${route.route}${route.hasChild ? '/*' : ''}`} element={<route.component />} />
                         ))
                     }
                 </Routes>
             </div>
         </div>
     )
};


export default MonetizationConfiguration

